import { FC, MouseEvent, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { IUploadFile } from 'store/models/general-models';
import { getFileLogo, truncateString } from 'utils';
import { SVG } from 'components';
import { Button } from 'components/ui';
import { DeleteButton, Icon, Wrapper } from './file.styled';
import { ReactComponent as trash } from 'assets/icons/trash.svg';

interface IProps {
  file: IUploadFile | File;
  inProccess: boolean;
  readOnly: boolean;
  onDeleteFile: (file: IUploadFile) => void;
  onDownload?: (fileId: string) => Promise<Blob>;
}

export const File: FC<IProps> = observer(
  ({ file, inProccess, readOnly, onDeleteFile, onDownload }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const truncatedFileName = truncateString(file.name, 20);

    const handleDownload = async () => {
      if ('file' in file) {
        setIsLoading(true);
        await file.downloadFile(
          onDownload ? () => onDownload(file.file) : undefined
        );
        setIsLoading(false);
      }
    };

    const handleDelete = (e: MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      onDeleteFile(file as IUploadFile);
    };

    return (
      <Wrapper>
        <Button
          data-tooltip-id={`file-${file.name}`}
          data-tooltip-variant={'info'}
          data-tooltip-delay-show={400}
          leftIcon={<Icon src={getFileLogo(file.name || '')} />}
          mode="neutral"
          size="s"
          pending={isLoading || inProccess}
          onClick={handleDownload}
        >
          {truncatedFileName}
          {truncatedFileName.length !== file.name.length &&
            !(inProccess || isLoading) && (
              <ReactTooltip
                id={`file-${file.name}`}
                variant={'info'}
                style={{ borderRadius: '8px', zIndex: 9999 }}
              >
                <div>{file.name}</div>
              </ReactTooltip>
            )}
        </Button>
        {!readOnly && (
          <DeleteButton onClick={handleDelete}>
            <SVG
              src={trash}
              props={{ color: 'currentColor', cursor: 'inherit' }}
            />
          </DeleteButton>
        )}
      </Wrapper>
    );
  }
);
